import { render } from "./CitiesView.vue?vue&type=template&id=781f554b"
import script from "./CitiesView.vue?vue&type=script&lang=js"
export * from "./CitiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__